/*
 * Copyright (c) CIRROM 2025.
 */

import variants from "./variants";
import { createTheme as createMuiTheme, Theme } from "@mui/material/styles";
import { typography } from "./typography";
import { breakpoints } from "./breakpoints";
import { shadows } from "../../../theme/shadows";
import { components } from "./components";

// Extend Material-UI theme with custom properties
export type MiraTheme = Theme & {
  sidebar: {
    color: string;
    background: string;
    header: {
      color: string;
      background: string;
      brand: {
        color: string;
      };
    };
    footer: {
      color: string;
      background: string;
    };
    badge: {
      color: string;
      background: string;
    };
  };
  header: {
    color: string;
    background: string;
    search: {
      color: string;
    };
    indicator: {
      background: string;
    };
  };
  footer: {
    color: string;
    background: string;
  };
};

export const createTheme = (name: string) => {
  let themeConfig = variants.find((variant) => variant.name === name);

  if (!themeConfig) {
    console.warn(new Error(`The theme ${name} is not valid`));
    themeConfig = variants[0];
  }

  return createMuiTheme(
    {
      spacing: 4,
      breakpoints: breakpoints,
      // @ts-expect-error Incompatible types
      components: components,
      typography: typography,
      // @ts-expect-error Incompatible types
      shadows: shadows,
      palette: themeConfig.palette,
    },
    {
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    }
  );
};
